export const productName = 'MEGAPACK MUSEOLOGÍA LISTO™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/1GWoYv3uGNCUKPn5MwsEMU/MOCKUP.png';

export const checkoutUrl = 'https://megapack-museologia-listo.impultienda.ar/checkout';

export const price = '$19.990 ARS';
export const priceBefore = '$127.000 ARS';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const volumePages = 754;
export const bonusPages = 427;
export const bonusTotalValue = '$82.000 ARS';

export const baseItems = [
  'TOMO 1: Fundamentos de la Museología',
  'TOMO 2: Patrimonio y Gestión de Colecciones',
  'TOMO 3: Documentación, Inventario y Catalogación',
  'TOMO 4: Conservación Preventiva y Gestión de Riesgos',
  'TOMO 5: Museografía y Diseño de Exposiciones',
  'TOMO 6: Educación en Museos y Mediación Cultural',
  'TOMO 7: Gestión y Administración de Museos',
  'TOMO 8: Públicos, Comunidad, Accesibilidad e Inclusión',
  'TOMO 9: Innovación, Tecnología y Museos del Futuro',
  'BONO 1: Banco de 150 Actividades de Museología',
  'BONO 2: Banco de 100 Casos Prácticos de Museología',
  'BONO 3: Banco de 200 Preguntas, Consignas y Debates de Museología',
  'BONO 4: Evaluaciones, Rúbricas y Trabajos Prácticos de Museología',
  'BONO 5: Proyecto Integrador — CREÁ UN MUSEO DESDE CERO',
  'Acceso de por vida y actualizaciones gratuitas',
];

export const checklist: Array<[string, string]> = [
  ['Contenido 100% argentino', 'Normativas internacionales, contexto de museos reales, políticas de patrimonio en Argentina y casos de éxito local.'],
  ['Material imprimible', 'Listo para usar en el aula o entregar directamente al alumno.'],
  ['Formularios y plantillas reales', 'Proyectos, presupuestos, catalogación y propuestas adaptados a 2026.'],
  ['Casos prácticos resueltos paso a paso', 'Con datos reales del campo de la museología argentina.'],
  ['Vocabulario técnico explicado', 'Sin jerga innecesaria, accesible para todos los niveles.'],
  ['Conexión con la actualidad', 'IA en curaduría, patrimonio digital, inclusión y accesibilidad.'],
  ['Historia y contexto argentino', 'Desde los orígenes de los museos hasta las tendencias 2026.'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios.'],
  ['Acceso inmediato', 'Descarga directa tras la compra.'],
  ['Actualizaciones gratuitas', 'Acceso de por vida al material.'],
];
